var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.52 71.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "personal-data"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5459",
    "data-name": "Path 5459",
    className: "cls-1",
    d: "M21.56,35.91H20.07V24.55l.64-.09a31.75,31.75,0,0,0,7.29-2l.55,1.38a33.26,33.26,0,0,1-7,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5460",
    "data-name": "Path 5460",
    className: "cls-1",
    d: "M35.76,57.15l-6.71-4.46.83-1.24,5.87,3.91,5.88-3.91.82,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5461",
    "data-name": "Path 5461",
    className: "cls-1",
    d: "M50,25.2h1.49V35.92H50Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5462",
    "data-name": "Path 5462",
    className: "cls-1",
    d: "M44.18,19.53a28.47,28.47,0,0,1-7.92-5.05l-.5-.45-.5.45a28.69,28.69,0,0,1-17,7.24l-1.13.09v14.1A23.14,23.14,0,0,0,27.39,55.17l8.37,5.58,8.36-5.58A23.1,23.1,0,0,0,54.43,35.91V21.81l-1.13-.08a28.2,28.2,0,0,1-9.12-2.2Zm8.76,16.38a21.64,21.64,0,0,1-9.65,18l-7.53,5-7.54-5a21.61,21.61,0,0,1-9.64-18V23.2A30.19,30.19,0,0,0,35.76,16a29.79,29.79,0,0,0,7.83,4.87,29.9,29.9,0,0,0,9.34,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5463",
    "data-name": "Path 5463",
    className: "cls-1",
    d: "M23.8,37.44a12,12,0,1,0,12-11.95h0A12,12,0,0,0,23.8,37.44Zm19.42,7.31a10.43,10.43,0,0,1-14.74.2l-.19-.2v-.91a.75.75,0,0,1,.56-.73l4.15-1a2.6,2.6,0,0,0,2,1.29v3H36.5v-3a2.6,2.6,0,0,0,2-1.29l4.15,1a.75.75,0,0,1,.56.73ZM36.5,38.19H35l-1.5-1.14V33.71h3v-1.5H32.39a3.2,3.2,0,0,1,2.71-1.49h2.15a.75.75,0,0,1,.75.75h0v5.58Zm.75,1.31v1.64c0,.14-.13.77-1.49.77s-1.49-.64-1.5-.75V39.48l.24.19H37Zm9-2.06a10.43,10.43,0,0,1-1.64,5.61A2.24,2.24,0,0,0,43,41.67L38.74,40.6V38.37l.75-.57V31.48a2.24,2.24,0,0,0-2.24-2.24H35.1a4.66,4.66,0,0,0-4.55,3.55l-.23.93H32V37.8l.75.57v2.24l-4.28,1.06a2.26,2.26,0,0,0-1.55,1.38,10.45,10.45,0,1,1,19.27-5.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.6c08b5093c771f75981437b505ff5bec.svg";
export { ForwardRef as ReactComponent };